import React from 'react';
import {
    Flex,
    FlexProps,
    Grid,
} from '@chakra-ui/react';
import {
    BlockHeader,
    GridCard,
    ImageModel,
} from 'shared';
import { LeadSmallSection } from 'features';
import { Helmet } from 'react-helmet-async';
// eslint-disable-next-line no-restricted-imports
import { richTextToString } from 'shared/lib/richtext-to-string';
import { useSweetShopPageState } from '../../store';

/**
 * Мемоизированный хедер блока, тк как он не перерисовывается
 */

export type SweetShopPageMainProps = {
    title: string,
    description?: any,
    image: ImageModel,
} & FlexProps & React.RefAttributes<HTMLDivElement>

export const SweetShopPageMain: React.FC<SweetShopPageMainProps> = ({
    title,
    description,
    image,
    ...props
}) => {
    const {
        sweetShopArticleCategories,
        leadFormPdf,
        cakeToOrderCards,
    } = useSweetShopPageState();

    return (
        <Flex
            {...props}
            flexDirection="column"
        >
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={richTextToString(description)} />
                <meta property="og:title" content={title} />
            </Helmet>
            <Flex>
                <BlockHeader
                    title={title}
                    imageSrc={image.url}
                    description={description}
                    width={{
                        base: '100vw',
                        sm: '100%',
                    }}
                />
            </Flex>
            <Grid
                background="#000000"
            >
                <LeadSmallSection
                    title="НЕ МОЖЕТЕ ОПРЕДЕЛИТЬСЯ?"
                    padding="2rem"
                    buttonText="Заказать звонок"
                    background="#000000"
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    width="100%"
                    margin="0 auto"
                    pdfUrl={leadFormPdf?.url}
                />
            </Grid>
            <Grid
                padding="2rem"
                gap="2rem"
                background="white"
                templateColumns={{
                    base: '1fr 1fr',
                    lg: '1fr 1fr 1fr 1fr',
                }}
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                width="100%"
                margin="0 auto"
            >
                {sweetShopArticleCategories.map(({ uid: uid2, name, image }) => (
                    <GridCard
                        flex="1 0 21%"
                        aspectRatio="2 / 3"
                        label={name}
                        to={`/sweet-shop/categories/${uid2}`}
                        src={image?.url}
                    />
                ))}
                {cakeToOrderCards.map(({ uid: uid2, name, image: image2 }) => (
                    <GridCard
                        flex="1 0 21%"
                        aspectRatio="2 / 3"
                        label={name}
                        to={`/sweet-shop/articles-to-order/${uid2}`}
                        src={image2?.url}
                    />
                ))}
            </Grid>
        </Flex>
    );
};
